var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('cloudHeader',{ref:"header",attrs:{"headerShow":!_vm.showAnc,"activeAnc":_vm.activeAnc},on:{"handleViewTo":_vm.handleViewTo}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }